// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { invPurchaseOrderId } from './InvPurchaseOrder';
import { invProductId } from './InvProduct';
import { z } from 'zod';
export const invPurchaseOrderItemId = (z.number());
export const invPurchaseOrderItem = z.object({
    id: invPurchaseOrderItemId,
    purchase_order_id: invPurchaseOrderId,
    product_id: invProductId,
    ordered_quantity: z.number(),
    received_quantity: z.number(),
    price_per_unit: z.number().nullable(),
    unit: z.string().nullable(),
    created_at: z.date().nullable(),
    updated_at: z.date().nullable(),
});
export const invPurchaseOrderItemInitializer = z.object({
    id: invPurchaseOrderItemId.optional(),
    purchase_order_id: invPurchaseOrderId,
    product_id: invProductId,
    ordered_quantity: z.number(),
    received_quantity: z.number().optional(),
    price_per_unit: z.number().optional().nullable(),
    unit: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
export const invPurchaseOrderItemMutator = z.object({
    id: invPurchaseOrderItemId.optional(),
    purchase_order_id: invPurchaseOrderId.optional(),
    product_id: invProductId.optional(),
    ordered_quantity: z.number().optional(),
    received_quantity: z.number().optional(),
    price_per_unit: z.number().optional().nullable(),
    unit: z.string().optional().nullable(),
    created_at: z.date().optional().nullable(),
    updated_at: z.date().optional().nullable(),
});
//# sourceMappingURL=InvPurchaseOrderItem.js.map